<div class="container">
  <div class="login">
    <div class="login__header">
      <h1>Admin Login</h1>
      <span>GenerEdge App</span>
    </div>

    <form [formGroup]="loginForm" class="form login__form">
      <div [class]="['form-group', emailInvalid && 'error']">
        <label for="email">Email</label>
        <input
          type="email"
          [class]="['form-control', emailInvalid && 'error']"
          id="email"
          name="email"
          required
          formControlName="email"
        />
        @if (emailInvalid) {
          <p class="form-feedback error">
            @if (loginForm.get('email')?.hasError('required')) {
              Email is Required
            } @else if (loginForm.get('email')?.hasError('validation')) {
              {{ loginForm.get('email')?.getError('validation') }}
            }
          </p>
        }
      </div>
      <div [class]="['form-group', passwordInvalid && 'error']">
        <label for="password">Password</label>
        <div class="input-group">
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            id="password"
            name="password"
            formControlName="password"
            required
          />
          <div class="input-group-append">
            <button (click)="toggleShowPassword()" class="input-group-button">
              @if (showPassword) {
                Hide
              } @else {
                Show
              }
            </button>
          </div>
        </div>
        @if (passwordInvalid) {
          <p class="form-feedback error">
            @if (loginForm.get('password')?.hasError('required')) {
              Password is Required
            } @else if (loginForm.get('password')?.hasError('validation')) {
              {{ loginForm.get('password')?.getError('validation') }}
            }
          </p>
        }
      </div>

      <button class="button" [disabled]="!loginForm.valid" (click)="onSubmit()">
        Submit
      </button>
      @for (error of errors(); track error.code) {
        <p class="form-feedback error">{{ error.detail }}</p>
      }
    </form>

    <!-- <form #form="ngForm" (ngSubmit)="onSubmit(form)" class="form login__form">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          class="form-control"
          id="email"
          name="email"
          required
          [(ngModel)]="loginData.email"
          #email="ngModel"
        />
      </div>
      @if (email.hasError('required')) {
        <p class="form-feedback error">Email is Required</p>
      }
      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          class="form-control"
          id="password"
          name="password"
          [(ngModel)]="loginData.email"
          #password="ngModel"
        />
      </div>
      @if (password.hasError('required')) {
        <p class="form-feedback error">Email is Required</p>
      }

      <input type="submit" value="Login" class="button" />
      @for (error of errors(); track error.code) {
        <p class="form-feedback error">{{ error.detail }}</p>
      }
    </form> -->
  </div>
</div>
